module.exports = __webpack_public_path__ + "img/jk-1.3cb94091.jpg";